import React from 'react';
import { FormattedMessage } from 'react-intl';

// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import Flex from '@atlaskit/primitives/components/flex';
import Box from '@atlaskit/primitives/box';
import { xcss } from '@atlaskit/primitives/xcss';
import Heading from '@atlaskit/heading/heading';
import CrossIcon from '@atlaskit/icon/core/cross';
import IconButton from '@atlaskit/button/icon/button';
import { JiraIcon } from '@atlaskit/logo';

import { fg } from '@confluence/feature-gating';

import { messages } from '../../messages.ts';

const headerStyles = xcss({
	flexShrink: 0,
});

const headerMessageStyle = xcss({
	paddingInline: 'space.100',
	font: 'font.heading.small',
	fontWeight: 'font.weight.medium',
	paddingBottom: 'space.025',
});

export const BulkCreateHeader = ({ onClose }: { onClose: () => void }): React.JSX.Element => {
	return (
		<Box
			padding="space.200"
			paddingBlockEnd="space.100"
			paddingInlineStart="space.300"
			xcss={headerStyles}
		>
			<Flex direction="row" justifyContent="space-between" alignItems="center">
				<Heading size="medium" as="h2">
					<Flex direction="row" justifyContent="space-between" alignItems="center">
						<Box>
							<JiraIcon size="small" appearance="brand" />
						</Box>
						<Box xcss={headerMessageStyle}>
							{fg('confluence-issue-terminology-refresh') ? (
								<FormattedMessage {...messages.bulkCreateHeaderTextIssueTermRefresh} />
							) : (
								<FormattedMessage {...messages.bulkCreateHeaderText} />
							)}
						</Box>
					</Flex>
				</Heading>
				<IconButton
					icon={() => <CrossIcon label="" spacing="none" />}
					appearance="subtle"
					label="close"
					onClick={onClose}
					testId="close-issue-create-panel-button"
				/>
			</Flex>
		</Box>
	);
};
